import { Download, QrCode } from 'lucide-react';
import useFetch from '../../hooks/useFetch';
import { useEvents } from '../../context/EventContext';
import { Card, Button, Loader, EmptyState, SectionTitle } from '../../components/UI';

/** The attendee's digital pass — what staff scan at entry, sessions and boarding. */
export default function AttendeePass() {
  const { event } = useEvents();
  const { data, loading } = useFetch('/users/me/qr');

  if (loading) return <Loader full label="Loading your pass" />;
  if (!data) return <EmptyState message="Your pass is not ready yet" icon={QrCode} />;

  return (
    <>
      <SectionTitle title="Digital pass" subtitle="Show this at entry, sessions and boarding" />
      <Card padding={28} style={{ maxWidth: 420, margin: '0 auto', textAlign: 'center' }}>
        <p style={{ fontSize: 11.5, color: 'var(--gold-500)', textTransform: 'uppercase', letterSpacing: 1.1, fontWeight: 600 }}>
          {event?.title || 'Golden Lotus'}
        </p>
        <div style={{ display: 'inline-block', padding: 18, background: '#fff', borderRadius: 'var(--r-lg)', marginTop: 18 }}>
          <img src={data.image} alt="Your pass QR code" style={{ width: 'min(260px, 62vw)', height: 'auto', aspectRatio: '1 / 1', display: 'block' }} />
        </div>
        <p style={{ fontSize: 20, fontWeight: 700, marginTop: 18 }}>{data.name}</p>
        {data.designation && <p style={{ fontSize: 13, color: 'var(--text-mid)', marginTop: 3 }}>{data.designation}</p>}
        <p style={{ fontSize: 12, color: 'var(--text-lo)', marginTop: 16, lineHeight: 1.6 }}>
          Turn your screen brightness up if the scanner struggles to read it.
        </p>
        <a href={data.image} download="golden-lotus-pass.png" style={{ display: 'inline-block', marginTop: 14 }}>
          <Button variant="outline" icon={Download}>Save to device</Button>
        </a>
      </Card>
    </>
  );
}
